<template>
  <BaseCard title="Order Summary">
    <div class="flex flex-col gap-y-2 divide-y divide-gray-100">
      <h3
        class="heading-xs"
        v-text="cart?.items[0].product.name"
      />
      <dl class="body-md flex flex-col gap-y-2 pt-2 font-semibold">
        <div class="flex items-center justify-between">
          <dt v-text="'Subtotal'" />
          <dd
            class="tabular-nums"
            v-text="formatMoney(cart?.prices.subtotal_excluding_tax.value)"
          />
        </div>

        <div class="flex items-center justify-between">
          <dt v-text="'Taxes'" />
          <dd
            class="tabular-nums"
            v-text="formatMoney(taxes)"
          />
        </div>

        <div
          v-if="storeCreditApplied && Boolean(cart?.prices.grand_total.value)"
          class="flex items-center justify-between"
        >
          <dt v-text="'Store Credit'" />
          <dd
            class="tabular-nums"
            v-text="formatMoney(-storeCreditAmount)"
          />
        </div>

        <div
          v-if="cart?.prices.discount"
          class="flex items-center justify-between"
        >
          <dt v-text="'Discount Applied'" />
          <dd
            class="tabular-nums"
            v-text="formatMoney(cart?.prices.discount.amount.value)"
          />
        </div>

        <div class="flex items-center justify-between border-t border-gray-100 pt-2">
          <dt v-text="'Total'" />
          <dd
            class="tabular-nums"
            v-text="formatMoney(cart?.prices.grand_total.value)"
          />
        </div>
      </dl>
    </div>
  </BaseCard>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import BaseCard from '@js/components/global/BaseCard.vue'

import { formatMoney } from '@js/utils/formatMoney'

import { Cart } from '@js/api/types/cart/Cart'

const props = defineProps<{
  cart: Cart | null,
  storeCreditApplied?: boolean,
  storeCreditAmount?: number,
}>()

const storeCreditApplied = computed(() => props.storeCreditApplied ?? false)
const storeCreditAmount = computed(() => props.storeCreditAmount ?? 0)

const taxes = computed(() =>
  props.cart
    ? props.cart.prices.subtotal_including_tax.value - props.cart.prices.subtotal_excluding_tax.value
    : 0,
)
</script>
